export const firebaseInfo = {
  apiKey:  "AIzaSyAs3DLxx0a7uVTzbNNB8A75c1TWwc_t-sE",
  authDomain: "app.intuitive.es", //"first-ffe56.firebaseapp.com",
  databaseURL: "https://first-ffe56.firebaseio.com",
  projectId: "first-ffe56",
  storageBucket: "first-ffe56.appspot.com",
  messagingSenderId: "585684144307"
};



// WEBPACK FOOTER //
// ./src/credentials.ts